import type { CityConfig } from "../city-template/types";

export const bettendorfConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Iowa HHS Vital Records", href: "https://hhs.iowa.gov/vital-records", description: "Official Iowa vital records office in Des Moines" },
    { label: "Marriage Licenses — Scott County Recorder", href: "https://www.scottcountyiowa.gov/recorder", description: "Scott County Recorder — marriage license issuance" },
    { label: "Divorce Records — Scott County Clerk of Court", href: "https://www.iowacourts.gov/", description: "Scott County Clerk of Court — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of Iowa HHS for online vital record orders" },
  ],
  city: "Bettendorf",
  state: "Iowa",
  stateAbbr: "IA",
  slug: "bettendorf",
  route: "/cities/bettendorf",
  title: "Emergency Passport Bettendorf, IA — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Bettendorf, IA — as fast as 24 hours. Serving the Quad Cities metro and Scott County. A+ BBB rated registered State Dept. courier serving QC manufacturing professionals, business travelers, and Mississippi River families. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Bettendorf, IA",
  heroSubtitle: "QC business trip to Canada with a week's notice? Mississippi River cruise and your passport expired? Manufacturing conference in Germany around the corner? We help Bettendorf and Quad Cities residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Bettendorf%20Iowa%20along%20the%20Mississippi%20River%20in%20the%20Quad%20Cities%20region%20with%20riverfront%20homes%20and%20downtown%20district%20at%20golden%20hour%20warm%20sunlight%20reflecting%20on%20the%20water%20professional%20drone%20photography%20vibrant%20natural%20landscape&width=1800&height=700&seq=bettendorf-hero-ia-2026&orientation=landscape",
  heroImageAlt: "Bettendorf Iowa Mississippi River Quad Cities cityscape at golden hour",
  geoPosition: "41.5267;-90.4969",
  geoPlacename: "Bettendorf, Iowa",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "101 Ida B Wells Dr, 9th Floor, Chicago, IL 60604",
    distance: "Located in the Chicago Loop — approximately 175 miles east of Bettendorf via I-88",
  },
  nearbyCitiesZips: [
    { name: "Bettendorf", zips: "52722" },
    { name: "Davenport", zips: "52801–52809" },
    { name: "Moline", zips: "61265, 61266" },
    { name: "Rock Island", zips: "61201, 61204" },
    { name: "East Moline", zips: "61244" },
    { name: "Eldridge", zips: "52748" },
    { name: "Pleasant Valley", zips: "52767" },
    { name: "Le Claire", zips: "52753" },
    { name: "Geneseo", zips: "61254" },
    { name: "Clinton", zips: "52732, 52733" },
    { name: "Muscatine", zips: "52761" },
    { name: "Silvis", zips: "61282" },
    { name: "Milan", zips: "61264" },
    { name: "Coal Valley", zips: "61240" },
    { name: "Port Byron", zips: "61275" },
    { name: "Hampton", zips: "61256" },
    { name: "Galesburg", zips: "61401" },
    { name: "Iowa City", zips: "52240–52246" },
    { name: "Rockford", zips: "61101–61126" },
    { name: "Peoria", zips: "61601–61655" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Quad Cities departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Quad Cities Coverage", desc: "Serving Bettendorf, Davenport, Moline, Rock Island, and East Moline" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Davenport, IA", route: "/cities/davenport" },
    { name: "Fast passport renewal in Chicago, IL", route: "/cities/chicago" },
    { name: "Emergency passport help in Des Moines, IA", route: "/cities/des-moines" },
    { name: "Urgent passport services in Iowa City, IA", route: "/cities/iowa-city" },
    { name: "Same-day passport help in Cedar Rapids, IA", route: "/cities/cedar-rapids" },
    { name: "Passport courier services in Madison, WI", route: "/cities/madison" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Bettendorf remotely via secure courier. We do not have a walk-in office in Bettendorf — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Scott County and the entire Quad Cities bi-state region.",
  fpcOfficeAddress: "801 Grand Ave, Des Moines, Iowa 50309",
  fpcOfficeDistance: "Serving all of Scott County and the Quad Cities bi-state metropolitan region including Rock Island, Henry, and Mercer counties",
  serviceAreaIntro: "From the Mississippi riverfront homes of Bettendorf to the revitalized downtown of Davenport, from the industrial muscle of Moline and Rock Island to the quiet suburban streets of Eldridge and Pleasant Valley, from the riverboat charm of Le Claire to the farm communities of rural Scott County — Fast Passport Center serves the entire Quad Cities bi-state region. We regularly help travelers from Bettendorf, Davenport, Moline, Rock Island, and East Moline get their passports fast without the 3-hour drive to Chicago.",
  nearbyCitiesIntro: "We serve all Bettendorf neighborhoods and the surrounding Quad Cities area including Davenport, Moline, Rock Island, East Moline, Eldridge, Pleasant Valley, Le Claire, Clinton, Muscatine, Geneseo, Silvis, Milan, and Coal Valley. If you are anywhere in Scott County or the Illinois Quad Cities, we have you covered.",
  howItWorksIntro: "Most Bettendorf travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Quad Cities travelers often face a 3-hour drive to the nearest regional passport agency in Chicago. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Bettendorf and Quad Cities travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Bettendorf? Here are the most common ones we hear from Quad Cities travelers.",
  statePageRoute: "/states/iowa",
  statePageName: "Iowa",
  dmvWebsite: "https://iowadot.gov/mvd",
  dmvLabel: "Iowa DOT — Motor Vehicle Division",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Bettendorf travelers with immediate departure needs — as fast as 24 hours for urgent international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean.",
      bullets: ["REAL ID compliant alternative", "Fits in your wallet", "Land/sea border crossing approved"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Replacement for water-damaged, torn, or otherwise mutilated passports that are no longer valid for travel.",
      bullets: ["Damage assessment guidance", "DS-11 replacement process", "Supporting documentation help"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Obtain a second valid U.S. passport for frequent international travelers who need overlapping visas.",
      bullets: ["For frequent business travelers", "Overlapping visa support", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
    { name: "Passport Card", description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean." },
    { name: "Damaged Passport", description: "Replacement for water-damaged, torn, or mutilated passports requiring DS-11 replacement." },
    { name: "Second Passport", description: "Second valid U.S. passport for frequent international travelers with overlapping visa needs." },
  ],
  testimonials: [
    {
      name: "David M.",
      location: "Bettendorf, IA",
      rating: 5,
      text: "Business trip to Germany with John Deere and my passport was about to expire. Fast Passport Center had my renewal in 30 hours. QC manufacturing professionals trust them for a reason.",
      service: "Passport Renewal",
    },
    {
      name: "Lisa R.",
      location: "Moline, IL",
      rating: 5,
      text: "Needed an emergency passport for a family wedding in Toronto. Got it in 28 hours without driving to Chicago. The dedicated agent kept me updated the whole time.",
      service: "Emergency Passport",
    },
    {
      name: "Tony K.",
      location: "Bettendorf, IA",
      rating: 5,
      text: "First passport for our daughter before a Mississippi River cruise through Canada. Fast Passport Center made the whole DS-11 process stress-free. 4 days start to finish.",
      service: "Child Passport",
    },

  ],
  facilities: [
    {
      id: "bett-1",
      name: "Bettendorf Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "4439 Devils Glen Rd",
      city: "Bettendorf",
      state: "IA",
      zip: "52722",
      phone: "(563) 332-5211",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Central Bettendorf",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Bettendorf facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "bett-2",
      name: "Davenport Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "401 W 2nd St",
      city: "Davenport",
      state: "IA",
      zip: "52801",
      phone: "(563) 323-1511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "5 miles west in Davenport",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Largest QC facility. Full passport services including photos. Appointment recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "bett-3",
      name: "Scott County Recorder's Office",
      type: "County Recorder Passport Acceptance",
      address: "600 W 4th St",
      city: "Davenport",
      state: "IA",
      zip: "52801",
      phone: "(563) 326-8621",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "5 miles west in Davenport",
      website: "https://www.scottcountyiowa.gov/recorder",
      websiteLabel: "Scott County Recorder",
      notes: "Accepts passport applications. Extended hours vs post office. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "bett-4",
      name: "Rock Island Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2633 11th St",
      city: "Rock Island",
      state: "IL",
      zip: "61201",
      phone: "(309) 788-2146",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "3 miles south in Rock Island, IL",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Illinois-side option. Full passport services available. Appointment recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "bett-5",
      name: "Moline Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "514 17th St",
      city: "Moline",
      state: "IL",
      zip: "61265",
      phone: "(309) 764-7501",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "5 miles south in Moline, IL",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Moline facility. Serves QC airport area. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "bett-6",
      name: "Muscatine Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3100 Cedar St",
      city: "Muscatine",
      state: "IA",
      zip: "52761",
      phone: "(563) 263-8041",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "30 miles southwest of Bettendorf",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Muscatine County. Full passport services available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 3 hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "QC photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Scott County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many QC applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Chicago regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Quad Cities families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "QC travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Bettendorf." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Bettendorf address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Bettendorf before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Bettendorf for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 3-hour drive to Chicago." },
    { q: "How fast can I renew my passport in Bettendorf?", a: "Fast Passport Center offers fast passport renewal in Bettendorf in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Bettendorf?", a: "The nearest regional passport agency to Bettendorf is the Chicago Passport Agency, approximately 175 miles east via I-88. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Bettendorf without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Bettendorf?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency — approximately 3 hours from Bettendorf — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Quad Cities residents." },
    { q: "Do you serve the entire Quad Cities region?", a: "Absolutely. Fast Passport Center serves the entire Quad Cities bi-state region including Bettendorf, Davenport, Moline, Rock Island, East Moline, Eldridge, and surrounding communities. Our courier service works seamlessly from any address in Scott County, Rock Island County, and the wider QC metro." },
    { q: "Can I expedite a child passport in Bettendorf?", a: "Yes. Fast Passport Center expedites child passports in Bettendorf for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Quad Cities families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Bettendorf with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Chicago Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Bettendorf", address: "2333 Cumberland Square Dr, Bettendorf, IA 52722", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Bettendorf", address: "3503 Middle Rd, Bettendorf, IA 52722", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "Walmart Supercenter — Davenport", address: "3101 W Kimberly Rd, Davenport, IA 52806", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
    { name: "Walgreens — Moline", address: "4000 Avenue of the Cities, Moline, IL 61265", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "CVS Pharmacy — Rock Island", address: "3000 18th Ave, Rock Island, IL 61201", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "FedEx Office — Davenport", address: "3020 E 53rd St, Davenport, IA 52807", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.fedex.com/" },
  ],
  dmvLocations: [
    {
      name: "Iowa DOT — Davenport Driver's License",
      address: "902 W Kimberly Rd, Davenport, IA 52806",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver license and REAL ID services for Scott County. Appointment recommended.",
      featured: true,
    },
    {
      name: "Illinois SOS — Moline Driver Services",
      address: "3701 16th St, Moline, IL 61265",
      hours: "Mon–Fri: 8AM–5:30PM",
      note: "Illinois REAL ID services for QC residents. Walk-ins accepted.",
      featured: false,
    },
    {
      name: "Iowa DOT — Clinton Driver's License",
      address: "1900 N 3rd St, Clinton, IA 52732",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Clinton County. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "MLI",
      name: "Quad Cities International Airport",
      distance: "6 miles south of Bettendorf",
      address: "2200 69th Ave, Moline, IL 61265",
      note: "Primary QC airport with direct flights to Chicago, Dallas, Atlanta, Denver, and seasonal destinations. About 10 minutes from Bettendorf.",
      flightUrl: "https://www.qcairport.com/",
      flightLabel: "MLI Airport",
      featured: true,
    },
    {
      code: "CID",
      name: "Eastern Iowa Airport",
      distance: "70 miles west of Bettendorf",
      address: "2121 Arthur Collins Pkwy SW, Cedar Rapids, IA 52404",
      note: "Serves Cedar Rapids and Eastern Iowa with direct flights nationwide. About 1 hour 15 minutes from Bettendorf.",
      flightUrl: "https://www.eiairport.org/",
      flightLabel: "CID Airport",
      featured: false,
    },
    {
      code: "ORD",
      name: "O'Hare International Airport",
      distance: "160 miles east of Bettendorf",
      address: "10000 W O'Hare Ave, Chicago, IL 60666",
      note: "Major international hub with direct flights worldwide. About 2 hours 45 minutes from Bettendorf.",
      flightUrl: "https://www.flychicago.com/ohare/",
      flightLabel: "ORD Airport",
      featured: false,
    },
  ],
};